'use client'

import i18n from '@/lib/i18n'
import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import { useEffect } from 'react'
import { setTimezone } from '@/lib/utils/timezone'
import { SUPPORTED_LANGUAGES } from '.'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const I18nCompanySyncClient = () => {
  const company = useCompanyContext()
  const companyLanguage = company?.language
  const companyTimezone = company?.timezone

  useEffect(() => {
    try {
      const nextLng = (companyLanguage || 'ko-KR').split('-')[0]
      if (!SUPPORTED_LANGUAGES.includes(nextLng)) return
      if (typeof window !== 'undefined') {
        document.documentElement.lang = nextLng
      }
      if (i18n.language !== nextLng) {
        i18n.changeLanguage(nextLng)
        if (typeof window !== 'undefined') {
          localStorage.setItem('i18nextLng', nextLng)
        }
      }
    } catch (_) {
      // ignore
    }
  }, [companyLanguage])

  useEffect(() => {
    setTimezone(companyTimezone)
    dayjs.tz.setDefault(companyTimezone)
  }, [companyTimezone])

  return null
}

export default I18nCompanySyncClient
